export const notificationState = {
    message : '',
    errorCode : 0,
    statusCode : 0,
    notificationList : [],
    count : 0
}